import router from '../router'
import store from "../store";
import {
  getDevice,
  getQueryString
} from "@/config/utils";
import api from "@/api/index";
import {
  createSignature,
  goToWechatPage
} from "@/utils/index";
let device = getDevice()
import Vue from "vue";
let _this = new Vue();

export default {
  install() {
    const history = window.sessionStorage;
    let historyCount = history.getItem('count') * 1;
    router.beforeEach(function (to, from, next) {
      /* 路由发生变化修改页面title */
      if (to.meta.title) {
        document.title = to.meta.title
      }
      if (/\/http/.test(to.path)) {
        let url = to.path.split('http')[1];
        window.location.href = `http${url}`
      } else {
        //	next()
      }
      store.commit('updateLoadingStatus', {
        isLoading: true
      })
      let code = getQueryString("access_code");
      let token = getQueryString("token");
      let kbform = getQueryString("kbform");
      // 拿本地的token refresh换新
      let storage_token = sessionStorage.getItem("app_token");
      let storage_refreshToken = sessionStorage.getItem("refreshToken");
      // 登录
      if (!storage_token && code) {
        getUserToken(code)
      } else {
        // 判断有没有token
        if (storage_token) {
          // 获取微信token
          getWechatToken();
          // 进程
        } else {
          // 判断要不要登录
          if (to.meta.requireAuth) {
            //获取微信的token
            let targetUrl = window.location.href;
            window.location = goToWechatPage(targetUrl);
          } else {
            // 微信环境
            if (store.state.isWx) {
              if (to.meta.isWxData && kbform != 1) {
                let targetUrl = window.location.href;
                window.location = goToWechatPage(targetUrl);
              } else {
                getWechatToken();
              }
            } else {
              next()
            }
          }
        }
      }
      async function getUserToken(code) {
        let result = await api.getUserToken({
          code: code
        });
        if (result.status == 1) {
          if (result.data) {
            let resultData = result.data;
            sessionStorage.setItem("app_token", resultData.accessToken);
            sessionStorage.setItem("refreshToken", resultData.refreshToken);
            //获取微信的token
            await getWechatToken();
            next();
          } else {
            sessionStorage.setItem("app_token", "");
            sessionStorage.setItem("refreshToken", "");
            sessionStorage.setItem("wechatToken", "");
            let targetUrl = window.location.href;
            window.location = goToWechatPage(targetUrl);
          }
        } else {
          sessionStorage.setItem("app_token", "");
          sessionStorage.setItem("refreshToken", "");
          sessionStorage.setItem("wechatToken", "");
          let targetUrl = window.location.href;
          window.location = goToWechatPage(targetUrl);
        }
      }
      async function getWechatToken() {
        let result = await api.getWechatToken({
          url: location.href
        });
        if (result.status == 1) {
          if (result.data) {
            let wechatToken = result.data;
            sessionStorage.setItem("wechatToken", JSON.stringify(wechatToken));
          } else {
            sessionStorage.setItem("wechatToken", "");
          }
        }
        next();
      }
    });

    router.afterEach(function (to, from) {
      store.commit('updateLoadingStatus', {
        isLoading: false
      })
      if (device == "ios" || device == "iPhoneX") {
        if (!store.state.wxSignUrl) {
          store.commit('setUrl', document.URL)
          sessionStorage.setItem("wxSignUrl", document.URL);
          createSignature()
        }
      }
    })

    router.onError(function (err) {
      console.log(err)
      if (err && err != '{}') {
        _this.$alert({
          content: '因系统维护导致资源文件异常,请返回微信再重新进入。',
          onHide() {
            window.location.reload(true)
          }
        });
      }
    })

  }
}



// WEBPACK FOOTER //
// ./src/utils/routerIntercept.js